import React from 'react';
import TabRouting from '../../components/TabRouting';

const selectedMainTabIndex = 6;

const RejectionThresholdMain = () => {
    return <TabRouting selectedMainTabIndex={selectedMainTabIndex}></TabRouting>;
};
export default RejectionThresholdMain;
